export default __webpack_public_path__ + "static/media/clam.5ddc7ea0.svg";